import Back from "../../assets/svgs/LoginSignup/Step1/back.svg";
import { BackButton, ButtonContainer, NextButton } from "../../styles/PersonalInfoStep";

interface StepFormProps {
  onNext: (e: React.FormEvent) => void;
  onBack?: (e: React.FormEvent) => void;
  children: React.ReactNode;
  showBackButton?: boolean;
}

export const StepForm: React.FC<StepFormProps> = ({ onNext, onBack, children, showBackButton = true }) => {
    const handleSubmit = (e: React.FormEvent) => {
      e.preventDefault(); // Prevent page refresh
      onNext(e); // Call handleNext
    };
  
    const handleBack = (e: React.FormEvent) => {
      e.preventDefault();
      if (onBack) {
        onBack(e);
      }
    };
  
    return (
      <form onSubmit={handleSubmit}>
        {children}
        
        <ButtonContainer>
        {showBackButton && (
                    <BackButton type="button" onClick={handleBack}>
                      <img src={Back} alt="Back" />
                    </BackButton>
        )}
                    <NextButton as="button" type="submit">
                      Next
                    </NextButton>
                  </ButtonContainer>
      </form>
    );
  };